import styled from 'styled-components';

export const FooterContainer = styled.footer`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  pointer-events: auto;
  /* Prevent overflow during animation */
  overflow: hidden;
  contain: layout style paint;
  opacity: ${props => {
    if (props.$isCorporateMode) return '0';
    if (props.$isPreloading) return '0';
    return '1';
  }};
  visibility: ${props => {
    if (props.$isCorporateMode) return 'hidden';
    if (props.$isPreloading) return 'hidden';
    return 'visible';
  }};
  animation: ${props => {
    if (props.$isCorporateMode) return 'menuPopDown 0.6s ease-in-out forwards';
    if (props.$isPreloading) return 'none';
    return 'menuSlideUp 0.8s ease-in-out forwards';
  }};
  transition: opacity 0.1s ease-in-out, visibility 0.1s ease-in-out;

  @keyframes menuPopDown {
    0% {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
    30% {
      transform: translateX(-50%) translateY(-20px);
      opacity: 1;
    }
    100% {
      transform: translateX(-50%) translateY(150px);
      opacity: 0;
    }
  }

  @keyframes menuSlideUp {
    0% {
      transform: translateX(-50%) translateY(150px);
      opacity: 0;
    }
    100% {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 1200px) {
    bottom: 50px;
  }

  @media (max-width: 768px) {
    bottom: 20px;
  }
`;

export const ContactBar = styled.div`
  display: flex;
  width: 716px;
  height: 100px;
  justify-content: center;
  align-items: center;
  background: #fff3;
  border-radius: 10px;
  position: relative;

  @media (max-width: 1200px) {
    width: 90vw;
    max-width: 716px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    padding: 20px;
    gap: 15px;
  }
`;

export const ContactInfo = styled.div`
  position: absolute;
  left: 28px;
  top: 0;
  height: 100px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    height: auto;
  }
`;

export const Email = styled.a`
  color: #FFF;
  font-family: 'Generic-G80-RD-Standard-DEMO', 'PP Mori', -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.3px;
  text-decoration: none;
  cursor: url('/icons/pointer.svg') 10 0, pointer;
  transition: all 0.3s ease;
  display: inline-block;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: #FFF;
    transition: width 0.3s ease;
  }
  
  &::before {
    content: '👋';
    position: absolute;
    right: -35px;
    top: 50%;
    transform: translateY(-50%) scale(0);
    transform-origin: bottom right;
    transition: transform 0.3s ease, opacity 0.3s ease;
    font-size: 28px;
    opacity: 0;
    animation: none;
  }
  
  &:hover {
    color: #FFF;
    transform: scale(1.05);
    
    &::after {
      width: 100%;
    }
    
    &::before {
      transform: translateY(-50%) scale(1);
      opacity: 1;
      animation: wave 0.8s ease-in-out infinite;
    }
  }
  
  &:active {
    transform: scale(0.95);
    color: #FFF;
    
    &::after {
      background: #FF2200;
    }
    
    &::before {
      transform: translateY(-50%) scale(0.8);
    }
  }
  
  &:focus {
    outline: 2px solid #FF2200;
    outline-offset: 2px;
    border-radius: 2px;
  }
  
  @keyframes wave {
    0%, 100% {
      transform: translateY(-50%) scale(1) rotate(0deg);
    }
    50% {
      transform: translateY(-50%) scale(1) rotate(30deg);
    }
  }

  @media (max-width: 768px) {
    line-height: 1;
  }
`;

export const SiteToggles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 322px;
  height: 78px;
  transition: background 0.2s ease-in-out;
  background: ${props => props.$isCorporateMode ? '#fff3' : '#FF2200'};
  border-radius: 8px;
  padding: 0 10px;

  @media (max-width: 768px) {
    position: relative;
    right: auto;
    top: auto;
    transform: none;
  }

  @media (max-width: 410px) {
    /* Scale only width to match header scaling */
    width: calc(322px * ((80vw - 32px) / 358px));
    gap: 8px;
  }
`;

export const ToggleIcon = styled.img`
  width: auto;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
  opacity: ${props => props.$isActive ? 1 : 0.5};
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: block;
  image-rendaring: optimizeQuality;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  max-width: 100%;
  max-height: 100%;
  
  &:hover {
    opacity: 1;
  }
  
  &:active {
    opacity: 1;
  }

  @media (max-width: 410px) {
    /* Make images fit to container */
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: url('/icons/pointer.svg') 10 0, pointer;
  height: 50px
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    width: 100%;
    height: 2px;
    background: white;
    border-radius: 1px;
    opacity: ${props => props.$isActive ? '1' : '0'};
    transform: ${props => props.$isActive ? 'scaleX(1)' : 'scaleX(0)'};
    transform-origin: center;
    transition: all 0.3s ease;
  }

`;

export const SayHelloBtn = styled.button`
  display: flex;
  padding: 30px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #F20;
  border: none;
  cursor: url('/icons/pointer.svg') 10 0, pointer;
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease;
  color: #FFF;
  font-family: 'Generic-G80-RD-Standard-DEMO', 'PP Mori', -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.3px;

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #F20;
    transform: translateY(-50%) scale(1.05);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  @media (max-width: 768px) {
    position: relative;
    left: auto;
    top: auto;
    transform: none;

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }
`;
